export default "__VITE_ASSET__CftyOEGi__"